import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import api from '../../services/api';
import { ShoppingBag, Plus, Package, CheckCircle } from 'lucide-react';
import toast from 'react-hot-toast';
import './Compras.css';

const Compras = () => {
  const [abaAtiva, setAbaAtiva] = useState('fornecedores');
  const queryClient = useQueryClient();

  const { data: fornecedores } = useQuery(
    'fornecedores',
    async () => {
      const estabelecimento = queryClient.getQueryData('estabelecimento')?.data?.estabelecimento?._id;
      if (!estabelecimento) return { fornecedores: [] };
      const response = await api.get(`/api/compras/fornecedores?estabelecimento=${estabelecimento}`);
      return response.data.data;
    }
  );

  const { data: ordens } = useQuery(
    'ordens-compra',
    async () => {
      const estabelecimento = queryClient.getQueryData('estabelecimento')?.data?.estabelecimento?._id;
      if (!estabelecimento) return { ordens: [] };
      const response = await api.get(`/api/compras/ordens?estabelecimento=${estabelecimento}`);
      return response.data.data;
    }
  );

  return (
    <div className="compras-page">
      <div className="page-header">
        <div>
          <h2><ShoppingBag size={28} /> Compras</h2>
          <p>Gestão de fornecedores e ordens de compra</p>
        </div>
        <button className="btn btn-primary">
          <Plus size={20} />
          Nova Ordem
        </button>
      </div>

      <div className="abas-compras">
        <button
          className={`aba ${abaAtiva === 'fornecedores' ? 'ativa' : ''}`}
          onClick={() => setAbaAtiva('fornecedores')}
        >
          Fornecedores
        </button>
        <button
          className={`aba ${abaAtiva === 'ordens' ? 'ativa' : ''}`}
          onClick={() => setAbaAtiva('ordens')}
        >
          Ordens de Compra
        </button>
      </div>

      <div className="conteudo-aba">
        {abaAtiva === 'fornecedores' && (
          <div className="fornecedores-grid">
            {fornecedores?.fornecedores?.map(fornecedor => (
              <div key={fornecedor._id} className="fornecedor-card">
                <h3>{fornecedor.nome}</h3>
                <div className="fornecedor-info">
                  <p><strong>CNPJ:</strong> {fornecedor.cnpj || 'N/A'}</p>
                  <p><strong>Telefone:</strong> {fornecedor.contato?.telefone || 'N/A'}</p>
                  <p><strong>Email:</strong> {fornecedor.contato?.email || 'N/A'}</p>
                  <p><strong>Prazo:</strong> {fornecedor.prazoPagamento || 30} dias</p>
                </div>
                <span className={`status-badge ${fornecedor.ativo ? 'ativo' : 'inativo'}`}>
                  {fornecedor.ativo ? 'Ativo' : 'Inativo'}
                </span>
              </div>
            ))}
          </div>
        )}

        {abaAtiva === 'ordens' && (
          <div className="ordens-lista">
            {ordens?.ordens?.map(ordem => (
              <div key={ordem._id} className="ordem-card">
                <div className="ordem-header">
                  <div>
                    <h3>Ordem #{ordem.numero}</h3>
                    <p>Fornecedor: {ordem.fornecedor?.nome}</p>
                  </div>
                  <span className={`status-badge ${ordem.status}`}>
                    {ordem.status}
                  </span>
                </div>
                <div className="ordem-itens">
                  {ordem.itens?.map((item, idx) => (
                    <div key={idx} className="item-ordem">
                      <span>{item.quantidade}x</span>
                      <span>{item.produto?.nome}</span>
                      <span>R$ {item.subtotal.toFixed(2)}</span>
                    </div>
                  ))}
                </div>
                <div className="ordem-footer">
                  <strong>Total: R$ {ordem.total.toFixed(2)}</strong>
                  {ordem.status === 'aprovada' && (
                    <button
                      className="btn btn-success"
                      onClick={() => {
                        // Implementar recebimento
                        toast.success('Ordem recebida!');
                      }}
                    >
                      <CheckCircle size={20} />
                      Receber
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Compras;

